import createCustomAxios from '../utils/axios';
// export const baseUrl = 'http://zuul.drcnet.com.cn/search';
export const baseUrl = 'https://search.drcnet.com.cn/search';

const http = createCustomAxios(baseUrl);

//投融资查询 接口
export function getOptions(params) {
    return http({
        method: 'get',
        url: '/invest/getOptions',
        params,
    });
}


//首页筛选接口
export function gethistoryword(params) {
    return http({
        method: 'get',
        url: '/gethistoryword/',
        params,
    });
}

//获取搜索历史
export function getRelevantSearchHistory(params) {
    return http({
        method: 'get',
        url: '/getRelevantSearchHistory/',
        params,
    });
}

//热门热门
export function getPublicHotSearchHistory(params) {
    return http({
        method: 'get',
        url: '/getPublicHotSearchHistory/',
        params,
    });
}


//检索列表接口
export function getSearchString(data) {
    return http({
        method: 'POST',
        url: '/getSearchString/',
        data,
    });
}
export function getSearchAndStatistics(data) {
    return http({
        method: 'POST',
        url: '/getSearchString1/',
        data,
    });
}


//检索列表接口
export function getResultBody(data) {
    return http({
        method: 'POST',
        url: '/getResultBody/',
        data,
    });
}




// 推送标签
export function getTags(params) {
    return http({
        method: 'get',
        url: '/tag/getTags/',
        params,
    });
}


// 个人列表页，五个按钮的接口
export function updatetag(data) {
    return http({
        method: 'POST',
        url: '/tag/updatetag/',
        data,
    });
}

// 删除
export function deleteTagById(params) {
    return http({
        method: 'get',
        url: '/tag/deleteTagById/',
        params,
    });
}


// 添加标签
export function addTag(data) {
    return http({
        method: 'POST',
        url: '/tag/addTag/',
        data,
    });
}

// 检查标签是否存在
export function checkTagTitle(params) {
    return http({
        method: 'get',
        url: '/tag/checkTagTitle/',
        params,
    });
}


// 通过id获取标签
export function getTagById(params) {
    return http({
        method: 'get',
        url: '/tag/getTagById/',
        params,
    });
}
// 获取左侧项目栏目树
export function postLeftTree(data) {
    return http({
        method: 'POST',
        url: '/getLeftTree/?chnId=' + data,
    });
}

// 获取检索特殊站点信息
export function postSpecSite(data) {
    return http({
        method: 'POST',
        url: '/getSpecSite/',
    });
}

// 根据uid获取左侧栏目树
export function getLeftTreeByUid(params) {
    return http({
        method: 'get',
        url: 'https://www.drcnet.com.cn/reportapi/WebChannelCommonController/getAllSonMenus',
        params,
    });
}

// 文章批量下载接口
// token 
// docIds
export function downloadArticleZip(params){
    return http({
        method: 'get',
        url: 'https://www.drcnet.com.cn/reportapi/CommonController/common/downDocByIds',
        params,
        responseType: 'blob' 
    });
}

// 二级学科分类标准名称
export function getSubjectClassification(params){
    return http({
        method: 'get',
        url: 'https://www.drcnet.com.cn/reportapi/CommonController/common/getDocSubject',
        params
    });
}

// 综合版、教育版、党政版主题标准名称  以综合版为准
export function getThemeClassification(){
    return http({
        method: 'get',
        url: 'https://report.drcnet.com.cn/reportapi/WebChannelCommonController/getAllSonMenus?uid=A10203',
    });
}